import {
  Check,
  CheckCircle2,
  MessageSquareText,
  X,
} from "lucide-react";
import { createPortal } from "react-dom";
import {
  procurementStageOf,
} from "../../model";
import type { ApprovalRowContext } from "./approval-row-model";
import { ApprovalDecisionWorkspace } from "./ApprovalDecisionWorkspace";
import { ApprovalOverrideForm } from "./ApprovalOverrideForm";
import { ApprovalRevisionForm } from "./ApprovalRevisionForm";

export function ApprovalDossier({ context }: { context: ApprovalRowContext ;}) {
  const {
    request,
    user,
    closingRequestId,
    pendingDecision,
    setDecisionError,
    decisionSubmitting,
    setGmOverrideRequestId,
    closeExpandedRequest,
    openDecisionComposer,
    act,
    resolution,
    isActionable,
    selectedOffer,
    dossierComplete,
    gmFinalOffer,
    gmChangedManagerSelection,
    isExpanded,
  } = context;
  return (<>
    {isExpanded
      ? createPortal(
        <div
          className={`manager-dossier-modal-backdrop${closingRequestId === request.id ? " is-closing" : ""}`}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget)
              closeExpandedRequest();
          }}
        >
          <section
            className="manager-dossier-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={`manager-dossier-title-${request.id}`}
          >
            <div className="manager-dossier-modal-bar">
              <div className="manager-dossier-modal-heading">
                <div className="manager-dossier-modal-context">
                  <span>Satın alma kararı</span>
                  <i aria-hidden="true" />
                  <strong>{request.id}</strong>
                </div>
                <h2 id={`manager-dossier-title-${request.id}`}>
                  {request.title}
                </h2>
              </div>
              <div className="manager-dossier-modal-controls">
                <button
                  type="button"
                  className="manager-dossier-close"
                  aria-label="Karar dosyasını kapat"
                  onClick={closeExpandedRequest}
                >
                  <span>Kapat</span>
                  <X size={18} />
                </button>
              </div>
            </div>
            <div className="manager-dossier-detail">
              <ApprovalDecisionWorkspace context={context} />
              <div
                className={`approval-actions${pendingDecision?.requestId === request.id ? " is-composing" : ""}`}
              >
                <div>
                  <strong>
                    {resolution
                      ? "Karar kaydedildi"
                      : isActionable
                        ? dossierComplete
                          ? "Kararınız"
                          : "Sıradaki işlem"
                        : "Süreç durumu"}
                  </strong>
                  <span>
                    {resolution
                      ? "İşlem denetim geçmişine kaydedildi."
                      : !isActionable
                        ? "Bu dosyada yalnızca kayıtlı karar ve ticari bilgiler görüntülenebilir."
                        : dossierComplete
                          ? "İşlem denetim geçmişine kaydedilir."
                          : "Eksik dosya yalnızca Satın Alma Uzmanına iade edilebilir."}
                  </span>
                </div>
                {resolution ? (
                  <span
                    className={`resolution resolution-${resolution.toLowerCase()}`}
                  >
                    <CheckCircle2 size={16} /> {resolution}
                  </span>
                ) : !isActionable ? (
                  <span className="approval-readonly-status">
                    <CheckCircle2 size={16} />
                    {procurementStageOf(request)}
                  </span>
                ) : pendingDecision?.requestId ===
                  request.id ? null : (
                  <div className="approval-action-buttons">
                    {user.role === "SATIN_ALMA_MUDURU" ? (
                      <button
                        className="warning-button"
                        onClick={() =>
                          openDecisionComposer(
                            request.id,
                            "Uzmana geri gönder",
                          )
                        }
                      >
                        <MessageSquareText size={16} />
                        {dossierComplete
                          ? "Uzmana geri gönder"
                          : "Eksik dosyayı Uzmana gönder"}
                      </button>
                    ) : dossierComplete ? (
                      <button
                        className="reject-button"
                        onClick={() =>
                          openDecisionComposer(
                            request.id,
                            "Reddedildi",
                          )
                        }
                      >
                        <X size={16} /> Düzeltme için geri
                        gönder
                      </button>
                    ) : null}
                    {dossierComplete ? (
                      <button
                        className="approve-button"
                        disabled={
                          decisionSubmitting ||
                          (user.role === "GENEL_MUDUR" &&
                            !gmFinalOffer)
                        }
                        onClick={() => {
                          if (
                            user.role === "GENEL_MUDUR" &&
                            gmChangedManagerSelection
                          ) {
                            setDecisionError("");
                            setGmOverrideRequestId(request.id);
                            return;
                          }
                          void act(
                            request,
                            "Onaylandı",
                            "",
                            user.role === "GENEL_MUDUR"
                              ? gmFinalOffer?.id
                              : selectedOffer?.id,
                          );
                        }}
                      >
                        <Check size={17} />
                        {user.role === "SATIN_ALMA_MUDURU"
                          ? "Genel Müdüre ilet"
                          : gmChangedManagerSelection
                            ? "Seçimi değiştir ve nihai onayla"
                            : "Önerilen teklifi nihai onayla"}
                      </button>
                    ) : null}
                  </div>
                )}
              </div>
              <ApprovalRevisionForm context={context} />
              <ApprovalOverrideForm context={context} />
            </div>
          </section>
        </div>,
        document.body,
      )
      : null}
  </>);
}
